import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom';
import theme from './theme'; // Importar el tema personalizado
import Root from './routes/root';
import ErrorPage from './error-page';
import About from './routes/about';
import Transactions from './routes/transaction/transactions';
import '@fontsource/inter/400.css'; // Regular
import '@fontsource/inter/500.css'; // Semi-bold
import '@fontsource/inter/700.css'; // Bold
import { AuthProvider } from './providers/authProvider';
import { settingsRoutes } from './routes/settings/settings-routes';
import { LoginRoutes } from './routes/login/login-routes';
import { CollaboratorRoutes } from './routes/collaborators/collaborators-rutes';
import { terminalsRoutes } from './routes/terminals/terminal-routes';
import { JwtService } from './services/jwtService';
import { Settlements } from './routes/settlements/components/settlements';
import { AuditorMerchantsRoutes } from './routes/aditor-merchants/auditor-merchants.routes';
import { MerchantsRoutes } from './routes/merchants/merchants.routes';
import { LinksRoutes } from './routes/links/links-routes';
import './styles.css';
import Dashboard from './routes/home/Dashboard';

const checkAuthentication = () => {
  const token = JwtService.getJwt();
  if (!token) {
    return redirect('/login');
  }
  return null;
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root />,
    errorElement: <ErrorPage />,
    loader: checkAuthentication,
    children: [
      {
        path: 'home',
        element: <Dashboard />,
      },
      {
        path: 'about',
        element: <About />,
      },
      {
        path: 'transactions',
        element: <Transactions />,
      },
      {
        path: 'settlements',
        element: <Settlements />,
      },
      {
        path: 'collaborators',
        children: CollaboratorRoutes,
      },
      {
        path: 'merchants',
        children: MerchantsRoutes,
      },
      {
        path: 'auditor-merchants',
        children: AuditorMerchantsRoutes,
      },
      {
        path: 'settings',
        children: settingsRoutes,
      },
      {
        path: 'terminals',
        children: terminalsRoutes,
      },
      {
        path: 'links',
        children: LinksRoutes,
      },
    ],
  },
  {
    path: 'login',
    children: LoginRoutes,
  },
]);

function App() {
  return (
    <AuthProvider>
      <ChakraProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraProvider>
    </AuthProvider>
  );
}

export default App;
